import moment from 'moment-timezone';
/**
 *
 * @param {Date} date - A JavaScript Date Object
 * @returns {string} Time string in military format hh:mm
 */
export var toTime = function (date) {
    return date.getHours().toString().padStart(2, '0') + ":" + date
        .getMinutes()
        .toString()
        .padStart(2, '0');
};
/**
 *
 * @param {Date} date - A JavaScript Date Object
 * @returns {string} Time string in military format hh:mm ampm
 */
export var toSTime = function (date) {
    var time = toTime(date);
    var hour = parseInt(time.split(':')[0]);
    var minutes = time.split(':')[1];
    return hour > 12
        ? hour - 12 + ":" + minutes + "pm"
        : (hour == 0 ? 12 : hour) + ":" + minutes + (hour === 12 ? 'pm' : 'am');
};
/**
 * Return an event start from an specific date
 * @param {Date} _date - A JavaScript Date Object
 * @returns {string} Time string in military format hh:mm
 */
export var toTimeStart = function (_date) {
    var date = _date;
    if (date.getMinutes() < 30) {
        date.setMinutes(30);
    }
    else {
        date.setMinutes(0);
        date.setHours(date.getHours() + 1);
    }
    return date.getHours().toString().padStart(2, '0') + ":" + date
        .getMinutes()
        .toString()
        .padStart(2, '0');
};
/**
 * Return an event end from an specific date
 * @param {Date} _date - A JavaScript Date Object
 * @returns {string} Time string in military format hh:mm
 */
export var toTimeEnd = function (_date) {
    var date = _date;
    if (date.getMinutes() < 30) {
        date.setMinutes(0);
        date.setHours(date.getHours() + 1);
    }
    else {
        date.setMinutes(30);
        date.setHours(date.getHours() + 1);
    }
    return date.getHours().toString().padStart(2, '0') + ":" + date
        .getMinutes()
        .toString()
        .padStart(2, '0');
};
/**
 *
 * @param {Date} date - A JavaScript Date Object
 * @returns {string} Date string format yyyy-mm-dd
 */
export var toDateString = function (date) {
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    return year + "-" + month + "-" + day;
};
/**
 *
 * @param dateString Date string format yyyy-mm-dd
 * @returns {Date}
 */
export var toStringDate = function (dateString) {
    var splitDate = dateString.split('-');
    var year = parseInt(splitDate[0]);
    var month = parseInt(splitDate[1]);
    var day = parseInt(splitDate[2]);
    return new Date(year, month - 1, day);
};
/**
 * Get Duration in millisecond
 * @param start
 * @param end
 * @returns millisecond
 */
export var getTimeDuration = function (start, end) {
    var _start = new Date();
    var _end = new Date();
    _start.setHours(start.getHours());
    _start.setMinutes(start.getMinutes());
    _end.setHours(end.getHours());
    _end.setMinutes(end.getMinutes());
    if (end > start &&
        timeToMins(start.getHours(), start.getMinutes()) >
            timeToMins(end.getHours(), end.getMinutes())) {
        _end.setDate(_end.getDate() + 1);
    }
    return _end.getTime() - _start.getTime();
};
var timeToMins = function (hour, minute) {
    return hour * 60 + minute;
};
/**
 *  Get Date from a date and time string
 * @param date
 * @param time
 * @returns Date
 */
export var getDateFromString = function (date, time) {
    var hour = parseInt(time.split(':')[0]);
    var minute = parseInt(time.split(':')[1]);
    date.setHours(hour);
    date.setMinutes(minute);
    return date;
};
/**
 *  Convert the local date to a specific time zone without changing the time, returns UTC string format
 * @param date
 * @param timeZone
 * @returns sting
 */
export var getConvertedTimeZoneInUTC = function (date, timeZoneS) {
    var timezone = moment.tz(date.toISOString(), moment.tz.guess());
    var convertedTZ = timezone.clone().tz(timeZoneS, true);
    return convertedTZ.clone().tz('UTC').format();
};
/**
 *  Convert the local date to a specific time zone without changing the time, returns UTC string format
 * @param date
 * @param timeZone
 * @returns sting
 */
export var getRetainTimeZoneInUTC = function (date, timeZoneS, retainTz) {
    var timezone = moment.tz(date.toISOString(), moment.tz.guess());
    var convertedTZ = timezone.clone().tz(timeZoneS, true);
    if (retainTz) {
        convertedTZ = convertedTZ.clone().tz(retainTz);
    }
    var utc = convertedTZ.clone().tz('UTC', true).format();
    return utc;
};
/**
 * Convert timeZone from tz to another tz
 * @param date
 * @param fromTZ
 * @param toTZ
 * @returns
 */
export var convertTimeZone = function (date, fromTZ, toTZ) {
    var from = moment.tz(date, fromTZ);
    var to = from.clone().tz(toTZ);
    var final = to.clone().tz(fromTZ, true);
    return final.clone().tz('UTC').format();
};
/**
 * Return date with 00:00:00:00 time
 * @param date
 * @returns
 */
export var toBareDate = function (date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
export var getRemovedTimeZoneBuff = function (date, timeZoneS) {
    var timezone = moment.tz(date.toISOString(), timeZoneS);
    return timezone.clone().tz('UTC', true).format();
};
/**
 * Return date with 00:00:00 am/pm time
 * @param time string
 * @returns string
 */
export var convertFromMTime = function (input) {
    return moment(input, 'HH:mm:ss').format('h:mm:ss A');
};
/**
 *
 * @param timeString
 * @returns
 */
export var convertToHourMin = function (timeString) {
    var hour = timeString.split(':')[0];
    var min = timeString.split(':')[1];
    return hour + ":" + min;
};
//# sourceMappingURL=DateFormatter.js.map